module.exports = __webpack_public_path__ + "img/33_58.117ab363.png";